import {Routes, Route} from 'react-router-dom';
import { AuthContextProvider } from "../services/AuthContext";
import { ProtectedRoutesAdm } from "./ProtectedRoutes";
import { ProtectedRoutesBen } from './ProtectedRoutesBen';
import Login from '../pages/Login/Login';
import Unfound from "../pages/Unfound/Unfound";
import Unfound2 from "../pages/Unfound/Unfound2";
import UpClients from "../pages/Clients/UpClients";
import ListClients from "../pages/Clients/ListClients";
import Pricing from "../pages/Pricing/Pricing";
import ListAllCollaborators from "../pages/Collaborators/ListAllCollaborators";
import UpCollaborator from "../pages/Collaborators/UpCollaborator";
import UpProjects from "../pages/Projects/UpProjects";
import Client from "../pages/Clients/Client";
import ListAnalystCollab from "../pages/Collaborators/ListAnalystCollab";
import ListSupplierCollab from "../pages/Collaborators/ListSupplierCollab";
import Collabortor from "../pages/Collaborators/Collabortor";
import ListCollabProjectLeader from "../pages/Collaborators/ListCollabProjectLeader";
import ListCollabHumint from "../pages/Collaborators/ListCollabHumint";
import ListCollabDocumentsAnalysis from "../pages/Collaborators/ListCollabDocumentsAnalysis";
import ListCollabSurveillance from "../pages/Collaborators/ListCollabSurveillance";
import ListCollabTranslatorReviewer from "../pages/Collaborators/ListCollabTranslatorReviewer";
import ListCollabTechnology from "../pages/Collaborators/ListCollabTechnology";
import ListCollabAccounting from "../pages/Collaborators/ListCollabAccounting";
import ListCollabVirtualOffice from "../pages/Collaborators/ListCollabVirtualOffice";
import ListCollabDataBank from "../pages/Collaborators/ListCollabDataBank";
import ListCollabBank from "../pages/Collaborators/ListCollabBank";
import EmaiCLients from "../pages/Email/EmaiCLients";
import EmailClientsBrazil from "../pages/Email/EmailClientsBrazil";
import EmailClientsGlobal from "../pages/Email/EmailClientsGlobal";
import EmailSupplier from "../pages/Email/EmailSupplier";
import EmailAnalyst from "../pages/Email/EmailAnalyst";
import EmailAnalystBrazil from "../pages/Email/EmailAnalystBrazil";
import EmailAnalystGlobal from "../pages/Email/EmailAnalystGlobal";
import EmailSupplierBrazil from "../pages/Email/EmailSupplierBrazil";
import EmailSupplierGlobal from "../pages/Email/EmailSupplierGlobal";
import Project from "../pages/Projects/Project";
import OnGoing from "../pages/Projects/OnGoing";
import Delivered from "../pages/Projects/Delivered";
import ToBill from "../pages/Projects/ToBill";
import ToPay from "../pages/Projects/ToPay";
import ToRecive from "../pages/Projects/ToRecive";
import Recived from "../pages/Projects/Recived";
import ProjectToPay from "../pages/Projects/ProjectToPay";
import AllProjects from "../pages/Projects/AllProjects";
import Payed from "../pages/Projects/Payed";
import Finihed from "../pages/Projects/Finihed";
import StandBy from "../pages/Projects/StandBy";
import Analises from "../pages/Projects/Analises";
import ClientActive from "../pages/Clients/ClientActive";
import ClientInactive from  "../pages/Clients/ClientInactive"
import UnfoundClient from "../pages/Unfound/UnfoundClient";
import Calculadora from "../pages/Calculadora/Calculadora";
import Prospect from "../pages/Prospects/Prospect";
import ListProspects from "../pages/Prospects/ListProspects";
import UpProspect from "../pages/Prospects/UpProspect";
import EmailProspect from "../pages/Email/EmailProspect";
import EmailProspectBrazil from "../pages/Email/EmailProspectBrazil";
import EmailProspectGlobal from "../pages/Email/EmailProspectGlobal";
import EmailClientsAndProspects from "../pages/Email/EmailClientsAndProspects";
import EmailClientsAndProspectsBrazil from "../pages/Email/EmailClientsAndProspectsBrazil";
import EmailClientsAndProspectsGlobal from "../pages/Email/EmailClientsAndProspectsGlobal";
import ProjectTable from "../pages/Tables/ProjectTable";
import ClientsTable from "../pages/Tables/ClientsTable";
import AnalistsTable from "../pages/Tables/AnalistsTable";
import OnGoingTable from "../pages/Tables/OnGoingTable";
import ToPayTable from "../pages/Tables/ToPayTable";
import PayedTable from "../pages/Tables/PayedTable";
import ClientsProjectsTable from "../pages/Tables/ClientsProjectsTable";
import FilteredProjects from "../pages/Tables/FilteredProjects";
import PagamentoAnalistas from "../pages/Tables/PagamentoAnalistas";
import PagamentoLideres from "../pages/Tables/PagamentoLideres";
import AnalistasAPagar from "../pages/Projects/AnalistasAPagar";
import LideresAPagar from "../pages/Projects/LideresAPagar";
import FornecedoresAPagar from "../pages/Projects/FornecedoresAPagar";
import ListCollabJuridico from "../pages/Collaborators/ListCollabJuridico";
import FornecedorTable from "../pages/Tables/FornecedorTable";
import PagarFornecedores from "../pages/Tables/PagarFornecedores";

export const RouteList =()=>{


    return(
        <AuthContextProvider>
            <Routes>
                
                <Route path="/novocliente" element={
                    <ProtectedRoutesAdm>
                    <UpClients />
                    </ProtectedRoutesAdm>
              
                } />

                <Route path="/clientes" element={
                    <ProtectedRoutesAdm>
                    <ListClients />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/clientes/ativos" element={
                    <ProtectedRoutesAdm>
                    <ClientActive />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/clientes/inativos" element={
                    <ProtectedRoutesAdm>
                    <ClientInactive />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/cliente/:id" element={
                    <ProtectedRoutesAdm>
                    <Client />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/novocolaborador" element={
                    <ProtectedRoutesAdm>
                    <UpCollaborator />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/colaboradores" element={
                    <ProtectedRoutesAdm>
                    <ListAllCollaborators />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/analistas" element={
                    <ProtectedRoutesAdm>
                    <ListAnalystCollab />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/analistas/liderdeprojeto" element={
                    <ProtectedRoutesAdm>
                    <ListCollabProjectLeader />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/analistas/pesquisador" element={
                    <ProtectedRoutesAdm>
                    <ListCollabHumint />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/analistas/pesquisadordedocumentos" element={
                    <ProtectedRoutesAdm>
                    <ListCollabDocumentsAnalysis />
                    </ProtectedRoutesAdm>
              
                } />
                
                <Route path="/analistas/seguranca" element={
                    <ProtectedRoutesAdm>
                    <ListCollabSurveillance />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/analistas/tradutorrevisor" element={
                    <ProtectedRoutesAdm>
                    <ListCollabTranslatorReviewer />
                    </ProtectedRoutesAdm>
              
                } />

                <Route path="/fornecedores/contabilidade" element={
                    <ProtectedRoutesAdm>
                    <ListCollabAccounting />
                    </ProtectedRoutesAdm>
              
                } />

                   <Route path="/fornecedores/juridico" element={
                    <ProtectedRoutesAdm>
                    <ListCollabJuridico />
                    </ProtectedRoutesAdm>
              
                } />
                
                <Route path="/fornecedores/escritoriovirtual" element={
                    <ProtectedRoutesAdm>
                    <ListCollabVirtualOffice />
                    </ProtectedRoutesAdm>
              
                } />
               
                <Route path="/fornecedores/banco" element={
                    <ProtectedRoutesAdm>
                    <ListCollabBank />
                    </ProtectedRoutesAdm>
              
                } />
                
                <Route path="/fornecedores/bancodados" element={
                    <ProtectedRoutesAdm>
                    <ListCollabDataBank />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/fornecedores/tecnologia" element={
                    <ProtectedRoutesAdm>
                    <ListCollabTechnology />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/fornecedores" element={
                    <ProtectedRoutesAdm>
                    <ListSupplierCollab />
                    </ProtectedRoutesAdm>
              
                } />
               
                       <Route path="/email/prospeccoes" element={
                    <ProtectedRoutesBen>
                    <EmailProspect />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/prospeccoes/brasil" element={
                    <ProtectedRoutesBen>
                    <EmailProspectBrazil />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/prospeccoes/global" element={
                    <ProtectedRoutesBen>
                    <EmailProspectGlobal />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/clienteseprospeccoes" element={
                    <ProtectedRoutesBen>
                    <EmailClientsAndProspects />
                    </ProtectedRoutesBen>
              
                } />
                 <Route path="/email/clienteseprospeccoes/brasil" element={
                    <ProtectedRoutesBen>
                    <EmailClientsAndProspectsBrazil />
                    </ProtectedRoutesBen>
              
                } />
                 <Route path="/email/clienteseprospeccoes/global" element={
                    <ProtectedRoutesBen>
                    <EmailClientsAndProspectsGlobal />
                    </ProtectedRoutesBen>
              
                } />
                
                <Route path="/email/clientes" element={
                    <ProtectedRoutesBen>
                    <EmaiCLients />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/clientes/brasil" element={
                    <ProtectedRoutesBen>
                    <EmailClientsBrazil />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/clientes/global" element={
                    <ProtectedRoutesBen>
                    <EmailClientsGlobal />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/analistas" element={
                    <ProtectedRoutesBen>
                    <EmailAnalyst />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/analistas/brasil" element={
                    <ProtectedRoutesBen>
                    <EmailAnalystBrazil />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/analistas/global" element={
                    <ProtectedRoutesBen>
                    <EmailAnalystGlobal />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/fornecedores" element={
                    <ProtectedRoutesBen>
                    <EmailSupplier />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/email/fornecedores/brasil" element={
                    <ProtectedRoutesBen>
                    <EmailSupplierBrazil />
                    </ProtectedRoutesBen>
              
                } />
                 <Route path="/email/fornecedores/global" element={
                    <ProtectedRoutesBen>
                    <EmailSupplierGlobal />
                    </ProtectedRoutesBen>
              
                } />


                <Route path="/colaborador/:id" element={
                    <ProtectedRoutesAdm>
                    <Collabortor />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/novoprojeto" element={
                    <ProtectedRoutesAdm>
                    <UpProjects />
                    </ProtectedRoutesAdm>
              
                } />
          
           
                  <Route path="/" element={
                    <ProtectedRoutesAdm>
                    <OnGoing />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="projetos/entregues" element={
                    <ProtectedRoutesAdm>
                    <Delivered />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projeto/:id" element={
                    <ProtectedRoutesAdm>
                    <Project />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/projetos/acobrar" element={
                    <ProtectedRoutesAdm>
                    <ToBill />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/apagar" element={
                    <ProtectedRoutesAdm>
                    <ToPay />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/projetos/areceber" element={
                    <ProtectedRoutesAdm>
                    <ToRecive />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/depositado" element={
                    <ProtectedRoutesAdm>
                    <Recived />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projeto/pagamento/:id" element={
                    <ProtectedRoutesAdm>
                    <ProjectToPay />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/todos" element={
                    <ProtectedRoutesAdm>
                    <AllProjects />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/projetos/pago" element={
                    <ProtectedRoutesAdm>
                    <Payed />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/finalizado" element={
                    <ProtectedRoutesAdm>
                    <Finihed />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/empausa" element={
                    <ProtectedRoutesAdm>
                    <StandBy />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/emanalise" element={
                    <ProtectedRoutesAdm>
                    <Analises />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/analistasapagar" element={
                    <ProtectedRoutesAdm>
                    <AnalistasAPagar />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/projetos/lideresapagar" element={
                    <ProtectedRoutesAdm>
                    <LideresAPagar />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/projetos/fornecedoresapagar" element={
                    <ProtectedRoutesAdm>
                    <FornecedoresAPagar />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/precificador" element={
                    <ProtectedRoutesBen>
                    <Pricing />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/calculadora" element={
                    <ProtectedRoutesAdm>
                    <Calculadora />
                    </ProtectedRoutesAdm>
              
                } />
                <Route path="/novaprospeccao" element={
                    <ProtectedRoutesAdm>
                    <UpProspect />
                    </ProtectedRoutesAdm>
              
                } />
                 <Route path="/prospeccao/:id" element={
                    <ProtectedRoutesAdm>
                    <Prospect />
                    </ProtectedRoutesAdm>
              
                } />
                   <Route path="/prospeccoes" element={
                    <ProtectedRoutesAdm>
                    <ListProspects />
                    </ProtectedRoutesAdm>
              
                } />
               
                 <Route path="/tabela/projetos" element={
                    <ProtectedRoutesBen>
                    <ProjectTable />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/clientes" element={
                    <ProtectedRoutesBen>
                    <ClientsTable />
                    </ProtectedRoutesBen>
              
                } />
                  <Route path="/tabela/analistas" element={
                    <ProtectedRoutesBen>
                    <AnalistsTable />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/emandamento/analista/:id" element={
                    <ProtectedRoutesBen>
                    <OnGoingTable />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/apagar/analista/:id" element={
                    <ProtectedRoutesBen>
                    <ToPayTable />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/pago/analista/:id" element={
                    <ProtectedRoutesBen>
                    <PayedTable />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/clientes/projetos/:id" element={
                    <ProtectedRoutesBen>
                    <ClientsProjectsTable />
                    </ProtectedRoutesBen>
              
                } />
                  <Route path="/tabela/projetoperiodo" element={
                    <ProtectedRoutesBen>
                    <FilteredProjects />
                    </ProtectedRoutesBen>
              
                } />

                    <Route path="/tabela/pagamentoanalistas" element={
                    <ProtectedRoutesBen>
                    <PagamentoAnalistas />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/pagamentolideres" element={
                    <ProtectedRoutesBen>
                    <PagamentoLideres />
                    </ProtectedRoutesBen>
              
                } />
                <Route path="/tabela/fornecedores" element={
                    <ProtectedRoutesBen>
                    <FornecedorTable />
                    </ProtectedRoutesBen>
              
                } />
                    <Route path="/tabela/pagamentofornecedores" element={
                    <ProtectedRoutesBen>
                    <PagarFornecedores />
                    </ProtectedRoutesBen>
              
                } />


                
                <Route path="/login" element={<Login/>} />
                <Route path="/*" element={<Unfound/>} />
                <Route path="/unfound2" element={<Unfound2/>} />
                <Route path="cliente/*" element={<UnfoundClient/>} />
                
            </Routes>
        </AuthContextProvider>
    );

}